'use client';

import { useEffect } from 'react';

/**
 * App-like interaction guard: blocks the browser's native drag of images,
 * links and selected text so the UI feels like an application rather than a
 * web page. CSS (`-webkit-user-drag: none` in globals.css) already covers
 * WebKit/Blink; this listener is the cross-browser backstop — Firefox has no
 * user-drag support and would otherwise still let images and nav links be
 * picked up and dragged. Intentional HTML5 drag-and-drop (e.g. the custom
 * color reorder list) opts in via `draggable="true"` and passes through.
 */
export function NativeDragGuard() {
  useEffect(() => {
    const onDragStart = (event: DragEvent) => {
      const target = event.target;
      if (target instanceof Element && target.closest('[draggable="true"]')) {
        return;
      }
      event.preventDefault();
    };
    document.addEventListener('dragstart', onDragStart, { capture: true });
    return () => {
      document.removeEventListener('dragstart', onDragStart, {
        capture: true,
      });
    };
  }, []);

  return null;
}
